
export const initialState = {
   
   email: "",
    success: false,
    
  };

/**
 * @method to get user information stored in global state of redux
 * @param state
 * @param action
 * @returns
 */
export const notifyMeReducer = (state:  any = initialState , action: any) => {
  switch (action.type) {
    case "EMAILSAVE":
      
console.log("reducer saveemail")
      return {
        ...state,
        success: true,
       
      };
   

    default:
      return state;
  }
};
